// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import { Tabs } from 'react-bootstrap'
import classnames from 'classnames'

import { tabsProps } from './structure'
import './EntityTabs.css'

const EntityTabs = props => {
  const { className, ...attrs } = props
  return (
    <Tabs {...attrs} className={classnames('listing-shift-tabs', className)}>
      {props.children}
    </Tabs>
  )
}

EntityTabs.propTypes = tabsProps

export default EntityTabs
